import { actionCopyEnUs } from "./actionCopy";
import { listCopyEnUs } from "./listCopy";

export const templatesCopyEnUs = {
    templates: "Templates",
    navDescription: "Browse templates and invite patients to track outcomes.",
    myTemplatesTitle: "My templates",
    myTemplatesDescription:
        "Create and manage templates to quickly invite patients to track outcomes. Click a row to use a template, or open the menu for more actions.",
    myTemplatesAria: "My templates",
    publicTemplatesTitle: "Public templates",
    breadcrumbNew: "New",
    selectAtLeastOneTemplate: "Select at least one template",
    addTemplatesToAccount: (count) =>
        count === 1 ? "Add template to my account" : `Add ${count} templates to my account`,
    creatingTemplates: "Creating templates…",
    publicTemplatesDescription:
        "Browse ready-made setups and add them to your account, or make your own. Select a template to get started quickly.",
    browsePublic: "Browse Public",
    browsePublicAria: "Browse public templates",
    newTemplate: "New Template",
    newTemplateAria: "New template",
    makeMyOwn: "Make my own",
    favourites: "Favorites",
    noQuestionnaires: "No questionnaires",
    moreQuestionnaires: (count) => `+${count} more`,
    useTemplate: "Use template",
    newDiary: "New diary",
    searchPlaceholder: "Search templates...",
    searchAria: "Search templates",
    clearSearchAria: actionCopyEnUs.clearSearch,
    filters: actionCopyEnUs.filters,
    clearAll: actionCopyEnUs.clearAll,
    procedureFilterPrefix: "Procedure:",
    statusFilterPrefix: "Status:",
    substanceFilterPrefix: "Substance:",
    subsiteFilterPrefix: "Subsite:",
    siteFilterPrefix: "Site:",
    typeFilterPrefix: "Type:",
    areaFilterPrefix: "Area:",
    consultationFilterPrefix: "Consultation:",
    removeProcedureFilterAria: (label) => `Remove procedure filter ${label}`,
    removeStatusFilterAria: (label) => `Remove status filter ${label}`,
    removeOwnerFilterAria: (name) => `Remove owner filter ${name}`,
    removePeopleFilterAria: (name) => `Remove people filter ${name}`,
    removeSubstanceFilterAria: "Remove substance filter",
    removeSubsiteFilterAria: "Remove subsite filter",
    removeSiteFilterAria: "Remove site filter",
    removeShockwaveTypeFilterAria: "Remove shockwave type filter",
    removeAreaFilterAria: "Remove area filter",
    removeConsultationFilterAria: "Remove consultation filter",
    ownerFilterLabel: "Owner (clinician or secretary)",
    ownerFilterPlaceholder: "All users",
    statusFilterLabel: "Status",
    statusFilterPlaceholder: "All statuses",
    peopleOnTemplateLabel: "People on template",
    peopleOnTemplatePlaceholder: "Anyone on template",
    procedureTypeLabel: "Procedure type",
    procedureTypePlaceholder: "Any procedure type",
    areaLabel: "Area",
    substanceLabel: "Substance",
    subsiteLabel: "Subsite",
    typeLabel: "Type",
    siteLabel: "Site",
    consultationLabel: "Consultation",
    selectPlaceholder: "Select...",
    clearFilterAria: (label) => `Clear ${label}`,
    injection: "Injection",
    shockwave: "Shockwave",
    surgery: "Surgery",
    consultation: "Consultation",
    medication: "Medication",
    product: "Product",
    published: listCopyEnUs.published,
    draft: listCopyEnUs.draft,
    noTemplatesYet: "No templates yet",
    noMatchingTemplates: "No matching templates",
    noTemplatesYetHint: "Create your first template to quickly invite patients.",
    noMatchingHint: "Try adjusting your search or filters.",
    createFirstTemplate: "Create Your First Template",
    emptyTemplatesHelpLink: "How do I make a template?",
    tableHint:
        "Click a row to invite a patient from that template. Use New diary and edit on each row, or open the menu for favorites and more actions.",
    forms: "Forms",
    lastEdited: "Last edited",
    procedure: "Procedure",
    area: "Area",
    people: "People",
    details: "Details",
    actions: listCopyEnUs.actions,
    select: "Select",
    useTemplateAria: "New diary",
    editTemplateAria: "Edit template",
    tapToUseTemplate: "Tap to use this template",
    useThisTemplateAria: "Use this template",
    clickRowToUseAria: "Click row to use this template",
    publicTemplatesTableAria: "Public templates",
    yourTemplatesTableAria: "Your templates; choose a row to use that template, or use actions on each row",
    noTemplatesInView: "No templates in this view.",
    showingTemplatesRange: (start, end, total) => `Showing templates ${start} to ${end} of ${total}`,
    previous: actionCopyEnUs.previous,
    next: actionCopyEnUs.next,
    save: actionCopyEnUs.save,
    rename: actionCopyEnUs.rename,
    editTemplate: "Edit Template",
    addToFavourites: "Add to favorites",
    removeFromFavourites: "Remove from favorites",
    copyUrl: "Copy URL",
    shareTemplate: "Share Template",
    labelsAndDiaryType: "Labels and diary type",
    publishTemplate: "Publish Template",
    linkToMasterTemplate: "Link to master template",
    duplicate: actionCopyEnUs.duplicate,
    delete: actionCopyEnUs.delete,
    deleteTemplateTitle: "Delete Template",
    deleteTemplateDescription: "Are you sure you want to delete this template? This action cannot be undone.",
    cancel: actionCopyEnUs.cancel,
    templateUpdatedToast: "Template updated successfully",
    copiedToClipboardToast: "Copied to clipboard",
    unnamedTemplate: "Unnamed Template",
    questionnaireSchedule: "Questionnaire Schedule",
    interventionStep: "Intervention",
    injectionDetails: "Injection Details",
    surgeryClinicians: "Surgery Clinicians",
    surgeryDetails: "Surgery Details",
    shockwaveClinicians: "Shockwave Clinicians",
    shockwaveDetails: "Shockwave Details",
    noIntervention: "No intervention",
    dateStep: "Date",
    dateQuestion: "Which date do follow-ups count from?",
    dateDiaryStart: "Start from the day the diary is created",
    dateDiaryStartHint: "Questionnaires start straight away. The patient is not asked for a date.",
    dateAskPatient: "Leave blank - the patient tells us",
    dateAskPatientHint: "The patient gives the date when they set up their diary. You can also add it later.",
    saveTemplate: "Save template",
    lockLabel: "Lock",
    unlockLabel: "Unlock",
    lockedLabel: "Locked",
    lockedByTemplateCreator: "Locked by template creator",
    usageInstructionsPlaceholder: "e.g. Wear for 2 hours daily, clean after each use",
    productNameRequired: "Product name is required",
    contactEmail: "Contact email",
    selectContactPlaceholder: "Select a contact email",
    defaultContactForOrganisation: (organisationNames) => `Default for ${organisationNames}`,
    templateCreatedTitle: "Template Created Successfully!",
    templateCreatedMessage: "Time saved is time earned!",
    templateNotFoundTitle: "Template Not Found",
    templateNotFoundDescription: "Unable to find the template. Please try again.",
    backToTemplates: "Back to templates",
    userFallback: (idPrefix) => `User ${idPrefix}...`,
    eventTypeLabel: (type: string) => {
        const map: Record<string, string> = {
            injection: "Injection",
            shockwave: "Shockwave",
            surgery: "Surgery",
            education: "Consultation",
            medication: "Medication",
            product: "Product",
        };
        return map[type] ?? type;
    },
    statusLabel: (status) => (status === "published" ? "Published" : "Draft"),
};
